var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7333 10.56V17.4267C25.7333 21.5333 23.3867 23.2933 19.8667 23.2933H8.14665C7.54665 23.2933 6.97332 23.24 6.43998 23.12C6.10665 23.0667 5.78666 22.9734 5.49333 22.8667C3.49333 22.12 2.27999 20.3867 2.27999 17.4267V10.56C2.27999 6.45331 4.62665 4.69336 8.14665 4.69336H19.8667C22.8533 4.69336 25 5.96002 25.5733 8.85335C25.6667 9.38669 25.7333 9.93331 25.7333 10.56Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.7333 14.56V21.4267C29.7333 25.5333 27.3867 27.2933 23.8667 27.2933H12.1466C11.16 27.2933 10.2667 27.16 9.49333 26.8667C7.90666 26.28 6.82665 25.0667 6.43998 23.12C6.97332 23.24 7.54665 23.2933 8.14665 23.2933H19.8667C23.3867 23.2933 25.7333 21.5333 25.7333 17.4267V10.56C25.7333 9.93329 25.68 9.37333 25.5733 8.85333C28.1067 9.38667 29.7333 11.1733 29.7333 14.56Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.52C15.944 17.52 17.52 15.944 17.52 14C17.52 12.056 15.944 10.48 14 10.48C12.056 10.48 10.48 12.056 10.48 14C10.48 15.944 12.056 17.52 14 17.52Z",
    fill: "#66BFE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37333 11C5.82667 11 5.37333 11.4533 5.37333 12V16C5.37333 16.5467 5.82667 17 6.37333 17C6.92 17 7.37333 16.5467 7.37333 16V12C7.37333 11.4533 6.93333 11 6.37333 11Z",
    fill: "#66BFE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6133 11C21.0667 11 20.6133 11.4533 20.6133 12V16C20.6133 16.5467 21.0667 17 21.6133 17C22.16 17 22.6133 16.5467 22.6133 16V12C22.6133 11.4533 22.1733 11 21.6133 11Z",
    fill: "#66BFE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.6baef185187ff38c4a6c66759d3767bd.svg";
export { ForwardRef as ReactComponent };